import { useMemo } from 'react';

type UseVideoOptions = {
  manageVisibility?: boolean;
  intersectionThreshold?: number;
  shouldPlay?: boolean;
  deferUntilVisible?: boolean;
};

const normalizeUrl = (url: string | undefined): string => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('//')) return `https:${url}`;
  return url;
};

export function useVideo(
  url: string | undefined,
  {} // manageVisibility = false,
  // intersectionThreshold = 0.25,
  // shouldPlay = true,
  // deferUntilVisible = false
  : UseVideoOptions = {}
) {
  const normalized = useMemo(() => normalizeUrl(url), [url]);

  return {
    videoRef: {} as React.MutableRefObject<HTMLVideoElement | null>,
    sourceUrl: normalized
  } as const;
}
